import React from "react"

import Icon from "icons"
import HeadingAccordion from "../../heading-accordion"
import {
  Container,
  List,
  ListItem,
  ListItemValue,
  Title,
  TitleWithIcon,
  TitleAndList,
  ListItemIcon,
} from "./styles"

const ProsAndCons = ({ pros, cons }) => {
  if (!pros && !cons) {
    return null
  }

  const element = {
    level: 3,
    text: "Pros & Cons",
  }

  return (
    <HeadingAccordion element={element}>
      <Container>
        <TitleAndList>
          <TitleWithIcon>
            <Icon id="thumbs-up" width={16} height={16} />
            <Title>Pros</Title>
          </TitleWithIcon>
          <List>
            {pros.map((pro) => (
              <ListItem key={pro}>
                <ListItemIcon>
                  <Icon id="checkmark" width={14} height={14} />
                </ListItemIcon>
                <ListItemValue dangerouslySetInnerHTML={{ __html: pro }} />
              </ListItem>
            ))}
          </List>
        </TitleAndList>
        <TitleAndList>
          <TitleWithIcon>
            <Icon id="thumbs-down" width={16} height={16} />
            <Title>Cons</Title>
          </TitleWithIcon>
          <List>
            {cons.map((con) => (
              <ListItem key={con}>
                <ListItemIcon>
                  <Icon id="close" width={14} height={14} color="#E03015" />
                </ListItemIcon>
                <ListItemValue dangerouslySetInnerHTML={{ __html: con }} />
              </ListItem>
            ))}
          </List>
        </TitleAndList>
      </Container>
    </HeadingAccordion>
  )
}

export default ProsAndCons
